<template>
    <div>
        <v-list-item @click.stop="dialog = true">
            <v-list-item-title >Drivers</v-list-item-title>
        </v-list-item>

        <v-dialog width="fit-content" v-model="dialog">
            <v-card v-if="dialog">
                <v-container>
                    <v-flex>
                        <v-row>
                            <h1 class="page-title">Drivers Working Here</h1>
                            <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                            <v-spacer class="line"></v-spacer>
                        </v-row>
                    </v-flex>

                    <v-simple-table>
                        <thead>
                        <tr>
                            <th class="text-left">Name</th>
                            <th class="text-left">Email</th>
                            <th class="text-left">Telephone</th>
                            <th class="text-left">Address</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="driver_item of driversListRestaurant" :key="driver_item.id">
                            <td class="person-name-td">
                                <span class="person-name"><edit-driver-modal :thisDriverData="driver_item">
                                    <a>{{driver_item.first_name + ' ' + driver_item.last_name}}</a>
                                </edit-driver-modal></span>
                            </td>
                            <td>{{ driver_item.email }}</td>
                            <td>{{ driver_item.phone }}</td>
                            <td>{{ driver_item.address_1 }}, {{ driver_item.address_2 }}</td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-container>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
import {mapGetters} from 'vuex'
import * as _ from 'lodash'

export default {
    name: "DriversListModal",
    props: ['restaurantId'],
    data(){
        return{
            dialog: false,
            thisRestaurantId: null,
        }
    },
    mounted() { 
        // --
    },
    computed: {
        ...mapGetters([
            'restaurants',
            'drivers'
        ]),
        driversListRestaurant() {
            if (_.isEmpty(this.restaurants)) {
                return [];
            }

            if (_.isEmpty(this.drivers)) {
                return [];
            }

            let restaurant = _.find(this.restaurants, p => p.id == this.restaurantId);

            if (!restaurant) return []; // impossible

            // filter drivers by area and restaurant
            let drivers = _.filter(this.drivers, driver => {
                if (driver.area_ids.length == 0) {
                    return true; // driver not assigned to any area
                }

                let driver_area_ids = _.map(driver.area_ids, p => p.area_id);
                if (driver_area_ids.indexOf(restaurant.area_id) === -1) {
                    return false;
                }

                // check driver assigned to restaurant
                if (driver.restaurant_ids.length == 0) {
                    return true; // driver not assigned to any restaurant
                }

                let driver_restaurant_item = _.find(driver.restaurant_ids, p => p.restaurant_id == restaurant.id);
                if (driver_restaurant_item) {
                    return true;
                }

                return false;
            });

            return drivers;
        },
    },
}
</script>

<style scoped>

</style>